import type { FaireProductEntity } from "../../entity_types/product";

export const p_tqm72ytyyn: FaireProductEntity = {
  token: "p_tqm72ytyyn",
  type: "product",
  name: "My Travel Journal: A Guided Journal (Gift for Travelers)",
  brandToken: "b_x27fkb4h4a",
  brandName: "Paige Tate & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/4e2fb66eedaa7cc5ed3019b1abd0aaf6e0e29b02eed51af4ee0689d4f3bade8f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1b351fb1e52eb8f00131aad53298d043169d7183f5c8247710322dfd29e6a5c.jpeg",
    "https://cdn.faire.com/fastly/de141dca66c3f162a706fd2c02bcabb29899e13d6dc1a43d19e0c3e26d7487a4.jpeg",
    "https://cdn.faire.com/fastly/6ac246146956111813e7303bb60467c51aea7b4ddcd244d06cbf5a601a1c23f4.jpeg",
    "https://cdn.faire.com/fastly/7ed1d451d1cd498cca1dfa619174355cac6f489d4728144a370a9b77f4ace110.jpeg",
    "https://cdn.faire.com/fastly/27f00affd9e5c3bf67382b2ed6ce5ccea1f206ffe85c600549312cebfa9bbdfd.jpeg",
  ],
  priceDollars: 13.66,
  description:
    "Keep track of your favorite travel memories with this beautiful heirloom-quality travel keepsake journal—the perfect gift for adventurous souls\n\nWhether it's a short weekend getaway or your dream international vacation, never forget a moment of your travels with this elegant travel journal from bestselling author and artist Korie Herold.\n\n• Elegant cloth cover with foil accents and lay-flat design\n• Guided journaling pages for memories, photos, and keepsakes\n• Archival quality paper with hand drawn artwork throughout\n• Ideal for travel lovers, newlyweds, graduates, and retirees\n• Created by a bestselling author, Korie Herold featured at Magnolia Market\n\nCategories: travel accessories, travel journals, travel journal notebook, journals and notebooks, gifts for men, outdoorsy, adventure book, adventure time, vintage, Faire Market 2026, mothers day",
  tags: [],
  msrpDollars: 27.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:50.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
